import { useNavigate } from "react-router-dom"; // Import useNavigate
import axios from "axios";
import { getNewAccessToken } from "./authUtils"; // Import the utility function for token refresh
import config from "../config";

// Custom hook to setup Axios with interceptors
const useAxios = () => {
  const navigate = useNavigate(); // Initialize useNavigate inside the hook

  // Create an Axios instance
  const axiosAPI = axios.create({
    baseURL: config.apiBaseUrl,
  });

  // Add a request interceptor
  axiosAPI.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("accessToken");
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Add a response interceptor
  axiosAPI.interceptors.response.use(
    (response) => {
      return response;
    },
    async (error) => {
      const originalRequest = error.config;

      // Check if the error is a 401 Unauthorized and the token is expired
      if (
        error.response &&
        error.response.status === 401 &&
        error.response.data.refreshTokenRequired
      ) {
        console.log("Unauthorized, token expired. Refreshing token...");

        // Try to get a new access token
        const newAccessToken = await getNewAccessToken();

        if (newAccessToken) {
          // Update the original request with the new access token
          originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;

          // Retry the original request with the new token
          return axios(originalRequest);
        } else {
          // If refreshing the token fails, log out the user
          navigate("/logout"); // Use useNavigate here inside the hook
          return Promise.reject("Token refresh failed. Please log in again.");
        }
      }

      return Promise.reject(error);
    }
  );

  return axiosAPI; // Return the Axios instance
};

export default useAxios;
